import type { GameFragment } from "../../../types";

const countGamesByProvider = (
  games: GameFragment[],
  isSearchView: boolean,
): Record<string, number> => {
  return games
    .filter((item) =>
      isSearchView
        ? item.__type === "search" || !item.__type
        : item.__type === "topgame",
    )
    .reduce<Record<string, number>>((acc, item) => {
      const providerName =
        item.menuItem?.[0]?.name || item.menuItem?.[0]?.handle;
      if (!providerName) return acc;
      const providerNameNormalized = providerName.toLowerCase();
      acc[providerNameNormalized] = (acc[providerNameNormalized] || 0) + 1;
      return acc;
    }, {});
};

export default countGamesByProvider;
